import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArkikProductResponse } from './arkik-products.models';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { HttpClientRequestService } from '@core/request-services/httpclient.request.services';

@Injectable({ providedIn: 'root' })
export class ArkikProductsService {
  constructor(private repo: HttpClientRequestService) {}

  getArkikProducts(): Observable<ArkikProductResponse[]> {
    const url = EndpointConstants.ApiProducts;
    return this.repo.post<ArkikProductResponse[]>(url, null);
  }
}
